import React from 'react';
import PropTypes from 'prop-types';
import { can } from '../../../../../../services';
import { NON_LHI_SOURCES } from 'config/constants';
import PhaseType from 'types/phase';
import * as tasks from './tasks';
import S from './phaseTaskBar.scss';
import isIfiPhase from './ifiUtils';

const SCHEDULING_TASKS = ['schedule_install', 'scheduling_checklist'];

const tasksFilter = ({ status, type }, { slug }, role) => {
  if (!can(role, 'update', 'phase_task', { status, slug })) return false;
  if (type === 'Installation' && status === 'scheduling') return SCHEDULING_TASKS.includes(slug);
  return true;
};

const filterByLRRP = (
  phase,
  { slug },
) => {
  const { lead_practices_required, year_built, source, workroom: { name } } = phase;
  // For non-LRRP tasks, always allow
  if (slug !== 'sign_lrrp' && slug !== 'lead_assessment') return true;

  // Hide LRRP tasks for IFI Installation/Workorder phases (use action button instead)
  if (isIfiPhase(phase) && (phase.type === 'Installation' || phase.type === 'Workorder')) {
    return false;
  }

  // Check if LRRP is required based on phase properties
  const lrrpRequired = slug === 'sign_lrrp' && (
    lead_practices_required &&
    (year_built || 0) <= 1977 &&
    // IFI is a non-LHI source that still requires LRRP documentation.
    (isIfiPhase(phase) || !NON_LHI_SOURCES.includes(source)) &&
    !name.includes('PFT-')
  );

  // For all remaining LRRP tasks, use the standard LRRP requirement check
  return lrrpRequired || slug === 'lead_assessment';
};

const tasksByVendor = ({ source }, { slug }) => !['before_photos', 'after_photos'].includes(slug) || source === 'RF';

const tasksByRocky = ({ rocky_managed: rockyManaged }, { slug }) =>
  !(rockyManaged && slug === 'send_to_floor_wizard');

const PhaseTasks = ({
  phase, role, employeeType, phase: { current_tasks: currentTasks }, handleTasksClose,
}) => <div className={S.phaseTaskBar__taskContainer}>
  {currentTasks
    .filter(task => tasksByVendor(phase, task))
    .filter(task => tasksByRocky(phase, task))
    .filter(task => filterByLRRP(phase, task))
    .filter(task => tasksFilter(phase, task, role))
    .map((task) => {
      const TaskType = tasks[task.slug] || tasks.phase_task;
      const cloneTask = Object.assign({}, task);
      if (phase.type !== 'Assessment' && employeeType === 'Employee' && task.name === 'En Route') cloneTask.name = 'Dispatch';
      return (<TaskType
        key={task.slug} phase={phase} task={cloneTask} handleTasksClose={handleTasksClose}
      />);
    })
  }
</div>;

PhaseTasks.propTypes = {
  phase: PhaseType.isRequired,
  role: PropTypes.string.isRequired,
  handleTasksClose: PropTypes.func.isRequired,
  employeeType: PropTypes.string,
};

export default PhaseTasks;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/phaseTasks.jsx